export const CONTROLS_GET = "CONTROLS_GET";
export const CONTROL_TOGGLE = "CONTROL_TOGGLE";

export const CONTROLS_FETCH = "CONTROLS_FETCH";
export const CONTROLS_FETCH_SUCCESS = "CONTROLS_FETCH_SUCCESS";



// WEBPACK FOOTER //
// ./src/modules/controls/actionTypes.js